import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from 'recharts';

// Reusable chart for baseline vs optimized comparison
export function ResultsChart({ data }: { data: Array<{ name: string; Baseline: number; Optimized: number }> }) {
  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />
          <XAxis dataKey="name" stroke="#d4af37" />
          <YAxis stroke="#d4af37" />
          <Tooltip contentStyle={{ background: '#000', border: '1px solid #00FF88', color: '#fff' }} />
          <Legend />
          <Bar dataKey="Baseline" fill="#d4af37" />
          <Bar dataKey="Optimized" fill="#00FF88" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ResultsChart;



















